import { Services } from '@sigma-frontend-libs/commons'

import { components, getInputMaskByOpenApiSchemaProperty } from '@/utils'

import buttonFilter from '@/components/button/filter'
import countryCode from '@/components/services/country-regions/commons/countryCode'

function renderRegionCodeField(h) {
  const { mask, maskOptions } = getInputMaskByOpenApiSchemaProperty(this.filterProperties.regionCode) || {}

  return h(
    components['text-field'],
    {
      props: {
        value: this.filterInputs.regionCode,
        label: this.getTranslate(`${Services['country-regions']}.labels.regionCode`),
        state: this.getFilterInputState('regionCode'),
        mask,
        maskOptions,
        dense: true,
        clearable: true,
        details: false
      },
      on: {
        input: event => {
          this.setFilterInput('regionCode', event)
        }
      }
    }
  )
}
function renderCountryCodeField(h) {
  return h(
    countryCode,
    {
      props: {
        value: this.filterInputs.countryCode,
        property: this.filterProperties.countryCode,
        error: this.getFilterInputError('countryCode')
      },
      on: {
        input: event => {
          this.setFilterInput('countryCode', event)
        }
      }
    }
  )
}

function renderFields(h) {
  return [
    renderRegionCodeField.call(this, h),
    renderCountryCodeField.call(this, h)
  ]
}

function renderButtonFilter(h) {
  return h(
    buttonFilter,
    {
      props: {
        value: this.filterInputs,
        defaultValue: this.defaultFilter
      },
      on: {
        input: event => {
          this.setFilterInputs(event)
        }
      }
    },
    renderFields.call(this, h)
  )
}

export default function(h) {
  if (this.viewport.breakpoint.lgUp) {
    return renderButtonFilter.call(this, h)
  } else {
    return h(
      'div',
      {
        class: 'grid grid-gap--8'
      },
      renderFields.call(this, h)
    )
  }
}
